<template>
  <UiModalContainer
    footer-classes="flex justify-between gap-3"
    :modal-show="showModal"
    :modal-width="50"
    @handleClick="handleClick"
  >
    <template v-slot:header>
      <span>Print Fee Invoice</span>
    </template>
    <div id="invoiceBody">
      <div class="flex flex-wrap mt-5 print:px-5">
        <div
          v-if="!generalPrintFormat"
          class="flex flex-col w-full justify-center font-bold text-1xl items-center"
        >
          <div>AMEEN PUBLIC HIGH SCHOOL</div>
          <div class="text-base font-normal">
            Hussain Khan Wala Tehsil and Distt.Kasur (03054141035)
          </div>
        </div>
        <div v-else class="flex">
          <div class="font-inter sm:text-2xl text-xl w-1/2 order-1 print:order-1 print:ml-0">
            {{ generalSettingInstituteName }}
          </div>
          <div v-if="siteSettingLogoURL" class="flex w-1/2 order-2 print:order-2 justify-end">
            <img
              class="md:ml-auto print:ml-auto w-16 h-16 rounded-full"
              :src="siteSettingLogoURL"
              :alt="generalSettingInstituteName"
            />
          </div>
        </div>

        <div class="flex flex-wrap print:px-5 font-roboto text-xs md:text-base">
          <div class="w-full sm:flex-row flex-col sm:gap-0 gap-5 flex mt-4">
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Student Name:</div>
              <div class="text-primary-grey-light capitalize">
                {{
                  (feeInvoice.student && feeInvoice.student.full_name) ||
                  GENERAL_CONSTANTS.NOT_APPLICABLE
                }}
              </div>
            </div>
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Guardian Name:</div>
              <div class="text-primary-grey-light">
                {{
                  (feeInvoice.student.student_info.guardians.length &&
                    feeInvoice.student.student_info.guardians[0].full_name) ||
                  GENERAL_CONSTANTS.NOT_APPLICABLE
                }}
              </div>
            </div>
          </div>
          <div class="w-full sm:flex-row flex-col sm:gap-0 gap-5 flex mt-2">
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Campus:</div>
              <div class="text-primary-grey-light">
                {{ currentCampusScope.title || GENERAL_CONSTANTS.NOT_APPLICABLE }}
              </div>
            </div>
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Class:</div>
              <div class="text-primary-grey-light">
                {{
                  (feeInvoice.fees_section.length && feeInvoice.fees_section[0].class.title) ||
                  GENERAL_CONSTANTS.NOT_APPLICABLE
                }}
              </div>
            </div>
          </div>
          <div class="w-full sm:flex-row flex-col sm:gap-0 gap-5 flex mt-2">
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">
                {{ pluralToSingular(sectionName).toLowerCase() }}:
              </div>
              <div class="text-primary-grey-light">
                {{
                  (feeInvoice.fees_section.length && feeInvoice.fees_section[0].title) ||
                  GENERAL_CONSTANTS.NOT_APPLICABLE
                }}
              </div>
            </div>
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Reg No:</div>
              <div class="text-primary-grey-light">
                {{
                  feeInvoice.student.student_info.registration_no ||
                  GENERAL_CONSTANTS.NOT_APPLICABLE
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="print:mx-5 w-full">
          <TableWrapper>
            <THead>
              <TRHead>
                <TH v-for="(head, index) in tableHeaders" :key="index">
                  {{ head }}
                </TH>
              </TRHead>
            </THead>
            <TBody>
              <TRBody v-for="(invoice, index) in feeInvoice.student_fees_receivings" :key="index">
                <TD>
                  {{ invoice?.student_fee?.fee_type?.title || GENERAL_CONSTANTS.NOT_APPLICABLE }}
                </TD>
                <TD>
                  {{
                    $filters.formattedDate(invoice.student_fee.due_date) ||
                    GENERAL_CONSTANTS.NOT_APPLICABLE
                  }}
                </TD>
                <TD>
                  {{ invoice?.student_fee?.fee_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}
                </TD>
                <TD>
                  {{ invoice?.total_paid_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}
                </TD>
                <TD>
                  {{ invoice?.student_fee?.fine_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}
                </TD>
                <TD>
                  {{ invoice?.student_fee?.discount_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}
                </TD>
                <TD>
                  {{ invoice?.paid_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}
                </TD>
              </TRBody>
              <TRBody>
                <TD>Total</TD>
                <TD colspan="5"></TD>
                <!-- Empty columns for alignment -->
                <TD>
                  = {{ feeInvoice?.total_receiving_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}/
                </TD>
              </TRBody>
            </TBody>
          </TableWrapper>
        </div>

        <div class="flex flex-wrap w-full print:px-5 font-roboto text-xs md:text-base">
          <div v-if="!generalPrintFormat" class="text-right w-full">
            فیس ہر ماہ کی 10 تاریخ تک لازمی جمع کروائیں۔10 تاریخ کے بعد 20 روپے جرمانہ وصول کیا جائے
            گا
          </div>
          <div class="w-full sm:flex-row flex-col sm:gap-0 gap-5 flex mt-5">
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Remaining Payable:</div>
              <div class="text-primary-grey-light">
                {{ feeInvoice.remaining_payable_amount || GENERAL_CONSTANTS.AMOUNT_ZERO }}
              </div>
            </div>
            <div class="flex sm:w-2/4 w-full">
              <div class="min-w-1.5 mr-2 font-bold">Received Date:</div>
              <div class="text-primary-grey-light">
                {{ $filters.formattedDate(feeInvoice.student_fees_receivings[0].paid_date) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <div class="flex justify-center gap-2 items-center">
        <div class="whitespace-nowrap text-sm font-semibold">Print Format:</div>

        <UiSingleSelect
          v-model="selectedPrintFormat"
          title="Select Print Format"
          name="Print Type"
          :options="printList"
          container-classes="w-[200px]"
          :hide-title="true"
          reduce="id"
          label="name"
          :hide-un-select-icon="true"
          :no-error="true"
        />
      </div>
      <UIButton button="primary" @click="printHandler()">
        <template v-if="isLoading">
          <Loader></Loader>
        </template>
        <template v-else>
          <span>Print</span>
        </template>
      </UIButton>
    </template>
  </UiModalContainer>
</template>

<script>
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import GENERAL_CONSTANTS from '@/src/constants/general-constants'
import { mapState, mapGetters } from 'vuex'
import { pluralToSingular, printDocument } from '@utils/generalUtil'
import UIButton from '@src/components/UiElements/UIButton.vue'
import {
  TableWrapper,
  TBody,
  TD,
  TH,
  THead,
  TRBody,
  TRHead,
} from '@src/components/UiElements/TableElements/index.js'

export default {
  name: 'DeleteExamComponent',
  components: {
    UiModalContainer,
    UIButton,
    UiSingleSelect,
    TableWrapper,
    TBody,
    TD,
    TH,
    THead,
    TRBody,
    TRHead,
  },
  data() {
    return {
      printList: [
        { name: 'APS', id: 'aps' },
        { name: 'General', id: 'general' },
      ],
      selectedPrintFormat: ' ',
      GENERAL_CONSTANTS,
      tableHeaders: ['Fee Type', 'Due Date', 'Fee', 'Paid', 'Fine', 'Discount', 'Cur.Receiving'],
    }
  },
  computed: {
    ...mapGetters('featureNaming', ['sectionName']),
    ...mapState('fee', ['showModal', 'feeInvoice']),
    ...mapState('layout', ['currentCampusScope']),
    ...mapState('settings', ['siteSettingLogoURL', 'generalSettingInstituteName']),
    generalPrintFormat() {
      return this.selectedPrintFormat === 'general'
    },
  },
  mounted() {
    let subDomain = JSON.parse(localStorage.getItem('subDomain')) || null
    this.selectedPrintFormat = subDomain === 'aps' ? 'aps' : 'general'
  },
  methods: {
    pluralToSingular,
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$store.commit('fee/SET_SHOW_MODAL', false)
          this.$store.commit('fee/SET_FEE_INVOICE', null)
          break
      }
    },
    printHandler() {
      printDocument('invoiceBody')
      this.$store.commit('fee/SET_SHOW_MODAL', false)
      this.$store.commit('fee/SET_FEE_INVOICE', null)
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-w-h {
  min-width: 34px;
  max-width: 34px;
  min-height: 34px;
  max-height: 34px;
}
.webkit-fill {
  width: -webkit-fill-available;
}
@media (min-width: 524px) and(max-width: 639px) {
  .custom-max-w {
    max-width: 465px;
  }
}
@media (min-width: 425px) and(max-width: 510px) {
  .custom-max-w {
    width: 360px;
  }
}
@media (min-width: 374px) and(max-width: 424px) {
  .custom-max-w {
    width: 305px;
  }
}
@media (min-width: 350px) and(max-width: 374px) {
  .custom-max-w {
    width: 289px;
  }
}
@media (min-width: 320px) and(max-width: 349px) {
  .custom-max-w {
    width: 267px;
  }
}
</style>
